"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidParamStyle = exports.isValidOas3Param = exports.isValidOas2Param = exports.isValidOasParam = exports.hasXLogo = void 0;
const json_1 = require("@stoplight/json");
const types_1 = require("@stoplight/types");
function hasXLogo(info) {
    return (0, json_1.isPlainObject)(info['x-logo']);
}
exports.hasXLogo = hasXLogo;
const VALID_OAS3_PARAM_LOCATION = ['query', 'header', 'path', 'cookie'];
const VALID_OAS2_PARAM_LOCATION = ['query', 'header', 'path', 'body', 'formData'];
const VALID_PARAM_STYLES = Object.values(types_1.HttpParamStyles);
const isValidOasParam = (param) => (0, json_1.isPlainObject)(param) && typeof param.name === 'string' && typeof param.in === 'string';
exports.isValidOasParam = isValidOasParam;
const isValidOas2Param = (param) => (0, exports.isValidOasParam)(param) && VALID_OAS2_PARAM_LOCATION.includes(param.in);
exports.isValidOas2Param = isValidOas2Param;
const isValidOas3Param = (param) => (0, exports.isValidOasParam)(param) && VALID_OAS3_PARAM_LOCATION.includes(param.in);
exports.isValidOas3Param = isValidOas3Param;
const isValidParamStyle = (style) => VALID_PARAM_STYLES.includes(style);
exports.isValidParamStyle = isValidParamStyle;
//# sourceMappingURL=guards.js.map